import { Theme } from '@mui/material';

export const createOwnEventBlockStyles = (
	theme: Theme,

	primaryColor
) => ({
	launchOwnEventBlock: {
		height: 'auto',
		borderRadius: '8px',
		padding: '24px',
		gap: '24px',
		border: `2px solid ${primaryColor}1A`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexDirection: { xs: 'column', md: 'row' },
		background: 'rgba(16, 16, 16, 1)',
	},
	launchOwnEventIconContainer: {
		height: '64px',
		width: '64px',
		background: 'rgba(255, 255, 255, 0.10)',
		borderRadius: 100,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: '28px',
		fontWeight: 600,

		[theme.breakpoints.down('sm')]: {
			height: '48px',
			width: '48px',
		},
	},
	launchOwnEventTextContainer: {
		color: 'white',
		fontSize: '17px',
		lineHeight: '21px',
		fontWeight: 700,
		fontFamily: 'Montserrat',

		'& span': {
			fontStyle: 'italic',
			fontFamily: 'Integral CF',
			fontSize: '14px',
			lineHeight: '17px',
			background: 'rgba(255, 255, 255, 0.10)',
			padding: '4px 10px',
			borderRadius: '13px',
			marginLeft: '6px',
		},
	},
	launchOwnEventButton: {
		padding: '10px 32px',
		backgroundColor: 'white',
		color: 'black',
		boxShadow: '0px 0px 10.800000190734863px rgba(255, 255, 255, 0.25)',
		border: '1px white solid',
		fontSize: '12px',
		fontWeight: '500',

		'&:hover': {
			backgroundColor: 'transparent',
			color: 'white',
		},
	},
});
